angular.module('impactx.catalog').controller('CatalogListCtrl', [
    'selectedListItems',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    '$redirect',
    'WarningService',
    'ShopViewService',
    'ToastService',
    '$route',
    'CatApprovalService',
    'CatalogCheckinService',
    '$routeParams',
    'CatalogActionsService',
    'DownloadService',
    'NewWindowService',
    '$scope',
    'ListHelperService',
    'AppConfiguration',
    'ixaCatalogActions',
    CatalogListCtrl]);

function CatalogListCtrl(selectedListItems, dataGen, $mdDialog, TranslationService, $redirect, WarningService, ShopViewService,
                         ToastService, $route, CatApprovalService, CatalogCheckinService, $routeParams, CatalogActionsService,
                         DownloadService, NewWindowService, $scope, ListHelperService, AppConfiguration, ixaCatalogActions) {
    var self = this;

    this.newCatalog = function (event, actionLabel, trns) {
        $mdDialog.show({
            controller: "CatalogTypeSelectionCtrl",
            controllerAs: "catalogTypeSelectionCtrl",
            templateUrl: "modules/catalog/templates/catalogtypeselectiondialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                internalCatLabel: trns.internalCat,
                externalCatLabel: trns.externalCat,
                uploadCatLabel: trns.uploadCat,
                confirmLabel: trns.confirm,
                abortLabel: trns.abort,
                actionLabel: actionLabel
            }
        });
    };

    this.getDetailLink = function () {
        var catalog = selectedListItems.getFirstSelectedItem();
        if (catalog) {
            if (!catalog.externalCatalog && !catalog.isSupplier.value) {
                return "internalcatalog/" + catalog.id;
            }
            else if (!catalog.externalCatalog && catalog.isSupplier.value) {
                return "internalcatalogsupplier/" + catalog.id;
            }
            else if (catalog.externalCatalog) {
                return "externalcatalog/" + catalog.id;
            }
        }
    };

    this.getCopyCatalogToViewLink = function () {
        var catalog = selectedListItems.getFirstSelectedItem();
        if (catalog) {
            return "copycatalogtoview/" + catalog.id;
        }
    };

    this.getArchiveLink = function () {
        var catalog = selectedListItems.getFirstSelectedItem();
        if (catalog) {
            return "catalogarchive/" + catalog.id;
        }
    };

    this.noAction = function () {
        return !selectedListItems.isSingleSelection ||
            (selectedListItems.getFirstSelectedItem().noLink && selectedListItems.getFirstSelectedItem().noLink.value)
    };

    this.canReplace = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canReplace == 1 && !self.noAction();
    };

    this.canReplaceCatOnApprovalProcess = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canReplaceOnApprovalProcess == 1 && !self.noAction();
    };

    this.canReplaceCatOnOwnEdit = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canReplaceOnOwnEdit == 1 && !self.noAction();
    };

    this.hasDetailAndQualityManagementLink = function () {
        return selectedListItems.isSingleSelection() && !self.noAction();
    };

    this.replace = function () {
        CatalogActionsService.replace(selectedListItems.getFirstSelectedId());
    };

    this.replaceCatOnApprovalProcess = function (event, trns) {
        CatalogActionsService.replaceOnApprovalProcess(event, selectedListItems.getFirstSelectedId(), trns);
    };

    this.replaceCatOnOwnEdit = function (event, trns) {
        CatalogActionsService.replaceOnOwnEdit(event, selectedListItems.getFirstSelectedId(), trns);
    };

    this.getQualityManagementLink = function () {
        return "catalogqualitymanagement/" + selectedListItems.getFirstSelectedId();
    };

    this.downloadLog = function () {
        DownloadService.openDownloadPost('/catalog/download/importlog', {paramName: "catId", paramValue: selectedListItems.getFirstSelectedId()});
    };

    this.canApproveProfessional = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().catalogPurchaserATI > 0 && !self.noAction();
    };

    this.canEditProductCoding = function () {
        return self.canApproveProfessional() || self.canApproveTechnical();
    };

    this.canApproveTechnical = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().catalogManagerATI > 0 && !self.noAction();
    };

    this.canDenyApproval = function () {
        return self.canApproveTechnical() || self.canApproveProfessional();
    };

    this.canCheckIn = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canCheckinOrDeny === "1" && !self.noAction();
    };

    this.canDoneForward = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDoneForward === "1"
            && selectedListItems.getFirstSelectedItem().isAutoApproval === "0" && !self.noAction();
    };

    this.canSetLive = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDoneForward === "1"
            && selectedListItems.getFirstSelectedItem().isAutoApproval === "1" && !self.noAction();
    };

    this.canDiscard = function () {
        return selectedListItems.isSingleSelection() && (self.canCheckIn() || selectedListItems.getFirstSelectedItem().canDiscard === "1")
            && !self.canDenyApproval() && !self.noAction();
    };

    this.canCheckinAndMoveForward = function () {
        return selectedListItems.isSingleSelection() && (selectedListItems.getFirstSelectedItem().canCheckinAndMoveForward === "1") && !self.noAction();
    };

    this.approveTechnical = function(event) {
        CatApprovalService.approveCatalogs([selectedListItems.getFirstSelectedItem().catalogManagerATI], $route.reload, event);
    };

    this.approveProfessional = function(event) {
        CatApprovalService.approveCatalogs([selectedListItems.getFirstSelectedItem().catalogPurchaserATI], $route.reload, event);
    };

    this.denyProfessional = function() {
        CatApprovalService.denyCatalogs([selectedListItems.getFirstSelectedItem().catalogPurchaserATI], $route.reload);
    };

    this.denyTechnical = function() {
        CatApprovalService.denyCatalogs([selectedListItems.getFirstSelectedItem().catalogManagerATI], $route.reload);
    };

    this.checkIn = function () {
        var tmpScope = {};
        CatalogCheckinService.checkIn(tmpScope, selectedListItems.getFirstSelectedId()).then(function () {
            ToastService.openStandardToast(tmpScope.trns.checkInStarted);
            selectedListItems.clearSelectedItems();
            $redirect.reload();
        });
    };

    this.checkInAndMoveForward = function () {
        CatalogActionsService.checkInAndForwardToApproval(selectedListItems.getFirstSelectedId());
    };

    this.denyCheckedOut = function () {
        var route = "/cataloglist";
        if ($routeParams.preSetId) {
            route = route + "/" + selectedListItems.getFirstSelectedItem().replaceId;
        }
        CatApprovalService.denyCatalogDialog(selectedListItems.getFirstSelectedId(), function () {
            selectedListItems.clearSelectedItems();
            $redirect.redirectTo(null, route);
        });
    };

    this.doneForward = function () {
        CatApprovalService.forwardToApproval(selectedListItems.getFirstSelectedId(), function () {
            selectedListItems.clearSelectedItems();
            $redirect.reload();
        });
    };

    this.stop = function (event) {
        CatApprovalService.stopCatalog(selectedListItems.getFirstSelectedId(), $route.reload, event);
    };

    this.canStop = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canStop === "1";
    };

    this.canDelete = function () {
        if (selectedListItems.isSingleSelection()) {
            var selectedItem = selectedListItems.getFirstSelectedItem();
            return !!(selectedItem && selectedItem.canDiscardFailedImport && selectedItem.canDiscardFailedImport.value);
        }
        else {
            return false;
        }
    };

    this.canManageProductStocks = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canManageStocks == 1 && !self.noAction();
    };

    this.delete = function () {
        CatalogActionsService.delete(selectedListItems.getFirstSelectedId())
    };

    this.checkoutDialog = function (event, trns) {
        CatalogActionsService.checkOut(event, selectedListItems.getFirstSelectedId(), trns);
    };

    this.canCheckout = function () {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().canCheckout &&
            selectedListItems.getFirstSelectedItem().canCheckout.value && !self.noAction();
    };

    this.abortApproval = function (event, trns) {
        CatalogActionsService.abortApproval(event, selectedListItems.getFirstSelectedId(), trns);
    };

    this.abortImport = function () {
        CatalogActionsService.abortImport(selectedListItems.getFirstSelectedId());
    };

    this.abortRunningImport = function () {
        CatalogActionsService.abortRunningImport(selectedListItems.getFirstSelectedId());
    };

    this.canAbortApprovalProcess = function () {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().canAbortApprovalProcess
            && selectedListItems.getFirstSelectedItem().canAbortApprovalProcess.value;
    };

    self.getReviewLink = function () {
        return "checkedoutcataloglist/" + selectedListItems.getFirstSelectedId();
    };

    self.getCheckedInReviewLink = function () {
        return "checkedincataloglist/" + selectedListItems.getFirstSelectedId() + "/true";
    };

    self.getProductCodingLink = function () {
        return "productcoding/" + selectedListItems.getFirstSelectedId();
    };

    self.getProductStockLink = function () {
        return "productstocklist/" + selectedListItems.getFirstSelectedId();
    };

    self.canReview = function () {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().canReview === "1";
    };

    self.canReviewCheckedIn = function () {
        return selectedListItems.isSingleSelection() && !selectedListItems.getFirstSelectedItem().replaceId && !selectedListItems.getFirstSelectedItem().uploadReplaceId;
    };

    this.canAbortImport = function () {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().canAbortImport
            && selectedListItems.getFirstSelectedItem().canAbortImport.value;
    };

    this.canAbortRunningImport = function () {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().canAbortRunningImport
            && selectedListItems.getFirstSelectedItem().canAbortRunningImport.value;
    };

    this.activateShopView = function() {
        var item = selectedListItems.getFirstSelectedItem();
        ShopViewService.activateShopView({id: item.vcatId});
    };

    this.canViewShopLink = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().numberOfProducts &&
            selectedListItems.getFirstSelectedItem().numberOfProducts > 0 && selectedListItems.getFirstSelectedItem().vcatId
            && selectedListItems.getFirstSelectedItem().hasRightToViewShop.value;
    };

    this.canRunChangeProtocol = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canViewAndRunChangeRule
            && selectedListItems.getFirstSelectedItem().canViewAndRunChangeRule.value && !self.noAction();
    };

    this.canDenyFailure = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDenyFailure
            && selectedListItems.getFirstSelectedItem().canDenyFailure.value;
    };

    this.denyFailure = function () {
        CatalogActionsService.denyFailure(selectedListItems.getFirstSelectedId());
    };

    this.changeProtocolDialog = function(event) {
        var catalogId = selectedListItems.getFirstSelectedItem().id;
        CatalogActionsService.runChangeProtocolDialog(event, catalogId)
    };

    this.canAccessArchive = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canAccessArchive
            && selectedListItems.getFirstSelectedItem().canAccessArchive.value && !self.noAction();
    };

    this.downloadTemplate = function () {
        DownloadService.openDownloadPost('/catalog/stagingexcel/template')
    };

    this.canExportPrices = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canExportPrices
            && selectedListItems.getFirstSelectedItem().canExportPrices.value
    }

    this.showExportPricesDialog = function (event) {
        $mdDialog.show({
            controller: "CatalogPriceExportCtrl",
            controllerAs: "catalogPriceExportCtrl",
            templateUrl: "modules/catalog/templates/catalog-exportprices.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                catId: selectedListItems.getFirstSelectedId()
            }
        });
    }

    this.canImportPrices = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canImportPrices
            && selectedListItems.getFirstSelectedItem().canImportPrices.value
    };

    this.canRemoveOrderStop = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canRemoveOrderStop
            && selectedListItems.getFirstSelectedItem().canRemoveOrderStop.value
    };

    this.canCopyCatalogToView = function () {
        return selectedListItems.isSingleSelection() && AppConfiguration.get("enableCatalogToViewCopy");
    };

    this.showImportPricesDialog = function (event) {
        $mdDialog.show({
            controller: "CatalogPriceImportCtrl",
            controllerAs: "catalogPriceImportCtrl",
            templateUrl: "modules/catalog/templates/catalog-importprices.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                catId: selectedListItems.getFirstSelectedId()
            }
        });
    };

    this.removeOrderStop = function (event) {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        dataGen.postAsForm($scope, {catId: selectedListItems.getFirstSelectedId(), removeManualOrderStop: false},
            "/catalog/orderstop/remove").then(function(data) {
                if (data.data.manualOrderStopSet) {
                    $mdDialog.show({
                        controller: "CatalogRemoveOrderStopCtrl",
                        controllerAs: "catalogRemoveOrderStopCtrl",
                        templateUrl: "modules/catalog/templates/catalog-remove-order-stop.dialog.tmpl.html",
                        parent: angular.element(document.body),
                        targetEvent: event,
                        clickOutsideToClose: true,
                        bindToController: true,
                        locals: {
                            catId: selectedListItems.getFirstSelectedId(),
                            message: data.data.message,
                            remove: data.data.remove
                        }
                    }).then(function () {
                        ListHelperService.refreshListData($scope, 'catalogListCtrl', {unselectRows: selectedItems});
                        ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                    });
                }
                else {
                    ListHelperService.refreshListData($scope, 'catalogListCtrl', {unselectRows: selectedItems});
                    ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                }
        });
    };

    this.canImportProductData = function () {
        return AppConfiguration.get("enableCatalogToViewCopy") && self.canCheckout();
    };

    this.importProductData = function (event, trns) {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));

        $mdDialog.show({
            controller: "ImportProductDataCtrl",
            controllerAs: "importProductDataCtrl",
            templateUrl: "modules/catalog/templates/import-product-data.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                headerLabel: trns.importProductData,
                importLabel: trns.import,
                cancelLabel: trns.cancel,
                dropzoneLabel: trns.importProductDataDropzone,
                catId: selectedListItems.getFirstSelectedId()
            }
        }).then(function () {
            ListHelperService.refreshListData($scope, 'catalogListCtrl', {unselectRows: selectedItems});
        }, function () {
            ListHelperService.refreshListData($scope, 'catalogListCtrl', {unselectRows: selectedItems});
        })
    };

    this.canEditOrderGroupSettings = function () {
        return selectedListItems.isSingleSelection() && !selectedListItems.getFirstSelectedItem().replaceId && !selectedListItems.getFirstSelectedItem().uploadReplaceId && !self.noAction();
    };

    this.editOrderGroupSettings = function (event, trns) {
        ixaCatalogActions.openCatalogOrderGroupSettings(selectedListItems.getFirstSelectedId()).then(function (data) {
            if (data && data.resultId && data.resultId > 0) {
                $redirect.redirectTo(null, "/anonymizationresult/" + data.resultId);
            }
        });
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: self.hasDetailAndQualityManagementLink,
            process: 'Catalog'
        },
        {
            label: "qualityManagement",
            linkFunction: self.getQualityManagementLink,
            type: 'link',
            condition: self.hasDetailAndQualityManagementLink,
            process: 'Catalog'
        },
        {
            label: "update",
            action: self.replace,
            condition: self.canReplace,
            process: 'SupplierCatalogUpload'
        },
        {
            label: "update",
            action: self.replaceCatOnApprovalProcess,
            condition: self.canReplaceCatOnApprovalProcess,
            process: 'SupplierCatalogUpload'
        },
        {
            label: "update",
            action: self.replaceCatOnOwnEdit,
            condition: self.canReplaceCatOnOwnEdit,
            process: 'SupplierCatalogUpload'
        },
        {
            label: "edit",
            action: self.checkoutDialog,
            condition: self.canCheckout,
            process: 'Catalog'
        },
        {
            label: 'edit',
            linkFunction: self.getReviewLink,
            type: 'link',
            condition: self.canReview,
            process: 'SupplierCatalogUpload'
        },
        {
            label: 'productList',
            linkFunction: self.getCheckedInReviewLink,
            type: 'link',
            condition: self.canReviewCheckedIn,
            process: 'Catalog'
        },
        {
            label: "checkin",
            action: self.checkIn,
            type: 'dialogaction',
            condition: self.canCheckIn
        },
        {
            label: "discard",
            action: self.denyCheckedOut,
            type: 'dialogaction',
            condition: self.canDiscard
        },
        {
            label: "discard",
            action: self.delete,
            type: 'dialogaction',
            condition: self.canDelete
        },
        {
            label: "doneForward",
            action: self.doneForward,
            type: 'dialogaction',
            condition: self.canDoneForward
        },
        {
            label: "doneForward",
            action: self.checkInAndMoveForward,
            type: 'dialogaction',
            condition: self.canCheckinAndMoveForward
        },
        {
            label: "productCoding",
            linkFunction: self.getProductCodingLink,
            type: 'link',
            condition: self.canEditProductCoding,
            process: "ProductCoding"
        },
        {
            label: "approve",
            action: self.approveProfessional,
            type: 'dialogaction',
            condition: self.canApproveProfessional
        },
        {
            label: "approve",
            action: self.approveTechnical,
            condition: self.canApproveTechnical
        },
        {
            label: "deny",
            action: self.denyProfessional,
            type: 'dialogaction',
            condition: self.canApproveProfessional
        },
        {
            label: "deny",
            action: self.denyTechnical,
            type: 'dialogaction',
            condition: self.canApproveTechnical
        },
        {
            label: "stop",
            action: self.stop,
            type: 'dialogaction',
            condition: self.canStop
        },
        {
            label: "setLive",
            action: self.doneForward,
            type: 'dialogaction',
            condition: self.canSetLive
        },
        {
            label: "abortApproval",
            action: self.abortApproval,
            type: 'dialogaction',
            condition: self.canAbortApprovalProcess
        },
        {
            label: "abortImport",
            action: self.abortImport,
            type: 'dialogaction',
            condition: self.canAbortImport
        },
        {
            label: "abortImport",
            action: self.abortRunningImport,
            type: 'dialogaction',
            condition: self.canAbortRunningImport
        },
        {
            label: "shopView",
            action: self.activateShopView,
            condition: self.canViewShopLink,
            process: 'Search'
        },
        {
            label: "changeProtocol",
            action: self.changeProtocolDialog,
            condition: self.canRunChangeProtocol,
            process: 'CatalogRunChangeRules'
        },
        {
            label: 'productStock',
            linkFunction: self.getProductStockLink,
            type: 'link',
            condition: self.canManageProductStocks
        },
        {
            label: "discard",
            action: self.denyFailure,
            type: 'dialogaction',
            condition: self.canDenyFailure
        },
        {
            label: "archive",
            linkFunction: self.getArchiveLink,
            type: 'link',
            condition: self.canAccessArchive,
            process: 'Catalog'
        },
        {
            label: "stagingExcelTemplate",
            action: self.downloadTemplate,
            condition: selectedListItems.isNoSelection,
            process: 'Catalog'
        },
        {
            label: "exportPrices",
            action: self.showExportPricesDialog,
            type: 'dialogaction',
            condition: self.canExportPrices,
            process: 'Catalog'
        },
        {
            label: "importPrices",
            action: self.showImportPricesDialog,
            type: 'dialogaction',
            condition: self.canImportPrices,
            process: 'Catalog'
        },
        {
            label: "removeOrderStop",
            action: self.removeOrderStop,
            type: 'dialogaction',
            condition: self.canRemoveOrderStop,
            process: 'Catalog'
        },
        {
            label: "copyCatalogToView",
            linkFunction: self.getCopyCatalogToViewLink,
            condition: self.canCopyCatalogToView,
            type: 'link',
            process: 'CopyCatalogToView'
        },
        {
            label: "importProductData",
            action: self.importProductData,
            condition: self.canImportProductData,
            process: 'CatalogImportProductData'
        },
        {
            label: "orderGroupSettings",
            action: self.editOrderGroupSettings,
            condition: self.canEditOrderGroupSettings,
            process: 'EditCatalogOrderGroupSettings'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/catalog/templates/cataloglist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/catalog/list',
        ctrl: this,
        id: "cataloglist",
        mainActionFunction: {id: "new", action: this.newCatalog, icon: "mdi-plus"},
        buttonDefinition: buttonDefinition,
        valuesInteger: [{name: "CAT_Id", value: $routeParams.preSetId ? $routeParams.preSetId : 0}]
    };

    this.getMeta = function () {
        return this.meta;
    };

    this.toggleTrackStock = function () {
        dataGen.post({}, {catId: selectedListItems.getFirstSelectedId()}, "/catalog/list/toggletrackstock").then(function (data) {
            if (data && data.errors.length === 0) {
                var item = selectedListItems.getFirstSelectedItem();
                item.trackStock.value = !item.trackStock.value;
            }
        });
    };
}